"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleDatePickerUi = SingleDatePickerUi;
var _api = require("@whitbread-eos/api");
var _server = require("@whitbread-eos/utils/server");
var _dateFns = require("date-fns");
var _locale = require("date-fns/locale");
var _image = _interopRequireDefault(require("next/image"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _Button = require("../Button");
var _CalendarSingle = require("../CalendarSingle");
var _createCustomLocale = require("../DatePicker/createCustomLocale");
var _Popover = require("../Popover");
var _Tooltip = require("../Tooltip");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function SingleDatePickerUi(_ref) {
  var {
    fromMonth,
    toMonth,
    setCurrentMonth,
    selectedDay,
    currentMonth,
    disabled,
    className,
    locale,
    formLabels,
    icons,
    onDateChange,
    showError = false,
    setShowError,
    placeholder
  } = _ref;
  var {
    months = [],
    weekdaysShort = []
  } = (formLabels === null || formLabels === void 0 ? void 0 : formLabels.datePicker) || {};
  var [isResetDisabled, setIsResetDisabled] = (0, _react.useState)(true);
  var localeFormatted = isShortMonth => {
    return locale === _api.LOCALES.EN ? (0, _createCustomLocale.createCustomLocale)(_locale.enGB, months, weekdaysShort, isShortMonth) : (0, _createCustomLocale.createCustomLocale)(_locale.de, months, weekdaysShort, isShortMonth);
  };
  var {
    t
  } = (0, _server.useTranslation)();
  var [popoverOpen, setPopoverOpen] = (0, _react.useState)(false);
  var handleDayClick = newDate => {
    if (onDateChange) {
      onDateChange(newDate);
      setIsResetDisabled(false);
    }
    if (setShowError) {
      setShowError(false);
    }
  };
  var handleMonthChange = month => {
    setCurrentMonth(month);
  };
  var onDayKeyPress = (day, activemodifiers, event) => {
    var deleteEvents = ['Delete', 'Backspace', 'Del', 'Clear'];
    if (deleteEvents.includes(event.key)) {
      onDateChange(undefined);
    }
  };
  function resetCalendar() {
    onDateChange(undefined);
    setShowError && setShowError(false);
    setIsResetDisabled(true);
    setCurrentMonth(new Date());
  }
  var renderButton = (0, _react.useCallback)(() => {
    var _icons$iconInputDat, _icons$iconChevronD;
    return (0, _jsxRuntime.jsxs)(_Button.Button, {
      "data-testid": "IB-Date-Picker-Input",
      id: "date",
      variant: "inputCalendarButton",
      size: "inputCalendarButton",
      className: (0, _server.cn)((0, _Button.buttonVariants)({
        variant: 'inputCalendarButton',
        size: 'inputCalendarButton'
      }), 'hover:border-darkGrey1 rounded min-w-[12.625rem] mobile:min-w-auto flex justify-between', !selectedDay && 'text-muted-foreground', showError && '-outline-offset-2 outline outline-2 outline-error', popoverOpen && 'outline outline-2 outline-primaryColor hover:outline-primaryColor outline-offset-[-2px] border-transparent'),
      children: [(0, _jsxRuntime.jsxs)("div", {
        className: "flex",
        children: [(0, _jsxRuntime.jsx)(_image.default, {
          className: "mr-3 h-6 w-6",
          loading: "eager",
          src: (0, _server.formatIBAssetsUrl)((_icons$iconInputDat = icons === null || icons === void 0 ? void 0 : icons['icon.input.datepicker']) !== null && _icons$iconInputDat !== void 0 ? _icons$iconInputDat : ''),
          alt: "calendar icon",
          width: 24,
          height: 24,
          "data-testid": "IB-Date-Picker-Calendar-Icon"
        }), (0, _jsxRuntime.jsx)("div", {
          className: textInput,
          "data-testid": "IB-Date-Picker-Text",
          children: selectedDay ? (0, _jsxRuntime.jsxs)("span", {
            children: [" ", (0, _dateFns.format)(selectedDay, 'dd MMM yy')]
          }) : (0, _jsxRuntime.jsx)("span", {
            children: placeholder
          })
        })]
      }), (0, _jsxRuntime.jsx)(_image.default, {
        className: "h-6 w-6",
        loading: "eager",
        src: (0, _server.formatIBAssetsUrl)((_icons$iconChevronD = icons === null || icons === void 0 ? void 0 : icons['icon.chevron.down']) !== null && _icons$iconChevronD !== void 0 ? _icons$iconChevronD : ''),
        alt: "dropdown icon",
        width: 24,
        height: 24,
        "data-testid": "IB-Date-Picker-Dropdown-Icon"
      })]
    });
  }, [icons, placeholder, popoverOpen, selectedDay, showError]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)("div", {
      className: (0, _server.cn)('flex gap-2', className),
      "data-testid": 'IB-Single-Date-Picker-Wrapper',
      children: (0, _jsxRuntime.jsxs)(_Popover.Popover, {
        open: popoverOpen,
        onOpenChange: setPopoverOpen,
        children: [showError ? (0, _jsxRuntime.jsx)(_Tooltip.ErrorTooltip, {
          icon: (0, _server.formatIBAssetsUrl)(icons === null || icons === void 0 ? void 0 : icons['icon.notification.error']),
          className: errorTooltipStyle,
          content: '',
          open: showError,
          testId: "IB-Date-Picker-ErrorTooltip",
          children: (0, _jsxRuntime.jsx)(_Popover.PopoverTrigger, {
            asChild: true,
            children: renderButton()
          })
        }) : (0, _jsxRuntime.jsx)(_Popover.PopoverTrigger, {
          asChild: true,
          children: renderButton()
        }), (0, _jsxRuntime.jsxs)(_Popover.PopoverContent, {
          className: "w-auto p-4",
          align: "start",
          children: [(0, _jsxRuntime.jsx)(_CalendarSingle.CalendarSingle, {
            fromMonth: fromMonth,
            toMonth: toMonth,
            onMonthChange: handleMonthChange,
            onDayKeyPress: onDayKeyPress,
            month: currentMonth,
            defaultMonth: currentMonth || selectedDay,
            onDayClick: handleDayClick,
            numberOfMonths: 1,
            mode: "single",
            selected: selectedDay,
            locale: localeFormatted(),
            disabled: disabled,
            components: {
              IconLeft: () => (0, _jsxRuntime.jsx)(_image.default, {
                className: iconStyle,
                src: (0, _server.formatIBAssetsUrl)(icons === null || icons === void 0 ? void 0 : icons['icon.chevron.left']),
                alt: "DatePicker Icon Left",
                width: 24,
                height: 24
              }),
              IconRight: () => (0, _jsxRuntime.jsx)(_image.default, {
                className: iconStyle,
                src: (0, _server.formatIBAssetsUrl)(icons === null || icons === void 0 ? void 0 : icons['icon.chevron.right']),
                alt: "DatePicker Icon Right",
                width: 24,
                height: 24
              })
            }
          }), (0, _jsxRuntime.jsxs)("div", {
            "data-testid": "IB-Date-Picker-Calendar-buttons",
            className: "mx-2 mb-2 flex justify-between gap-5",
            children: [(0, _jsxRuntime.jsx)(_Button.Button, {
              "data-testid": "IB-Date-Picker-Calendar-buttons-Reset",
              className: (0, _server.cn)((0, _Button.buttonVariants)({
                variant: 'footerButtons',
                size: 'footerButtons'
              }), 'border-none hover:underline disabled:text-lightGrey2'),
              onClick: () => {
                resetCalendar();
              },
              disabled: isResetDisabled,
              children: t('content.form.datePicker.reset')
            }), (0, _jsxRuntime.jsx)(_Button.Button, {
              "data-testid": "IB-Date-Picker-Calendar-buttons-Done",
              className: (0, _server.cn)((0, _Button.buttonVariants)({
                variant: 'footerButtons',
                size: 'footerButtons'
              }), 'border border-secondaryColor hover:shadow hover:shadow-lightGrey2'),
              onClick: () => setPopoverOpen(false),
              children: t('content.form.datePicker.done')
            })]
          })]
        })]
      })
    }), (0, _jsxRuntime.jsx)(_Tooltip.ErrorTooltip, {
      icon: (0, _server.formatIBAssetsUrl)(icons === null || icons === void 0 ? void 0 : icons['icon.notification.error']),
      content: '',
      open: showError,
      testId: "IB-Date-Picker-ErrorTooltip-Mobile"
    })]
  });
}
var textInput = 'text-base font-normal text-left text-darkGrey2 truncate inline-block';
var iconStyle = 'h-6 w-6';
var errorTooltipStyle = 'max-w-[90%]';